import { getPercent } from '@/shared/lib/getPercent';
import { Status } from '@/shared/types/Status';

import {
  DETERMINING_SPEAKERS_SEC,
  DETERMINING_SPEAKERS_TO_VOICE_SUGGEST_SEC,
  PROJECT_CREATED_TO_UPLOADING_SEC,
  SEPARATE_BACKGROUND_SEC,
  SEPARATE_BACKGROUND_TO_TRANSCRIBE_SEGMENTS_SEC,
  TRANSCRIBING_SEGMENTS_SEC,
  TRANSCRIBING_SEGMENTS_TO_DETERMINING_SPEAKERS_SEC,
  VIDEO_UPLOADED_TO_SEPARATE_BACKGROUND_SEC,
  VIDEO_UPLOADING_SEC,
  VOICE_SUGGESTING_SEC,
} from './mlAverageTasksDurations';

export const DST_SRT_UPLOADING_SEC_FOR_60_SEC_VIDEO =
  PROJECT_CREATED_TO_UPLOADING_SEC +
  VIDEO_UPLOADING_SEC +
  VIDEO_UPLOADED_TO_SEPARATE_BACKGROUND_SEC +
  SEPARATE_BACKGROUND_SEC +
  SEPARATE_BACKGROUND_TO_TRANSCRIBE_SEGMENTS_SEC +
  TRANSCRIBING_SEGMENTS_SEC +
  TRANSCRIBING_SEGMENTS_TO_DETERMINING_SPEAKERS_SEC +
  DETERMINING_SPEAKERS_SEC +
  DETERMINING_SPEAKERS_TO_VOICE_SUGGEST_SEC +
  VOICE_SUGGESTING_SEC;

const INITIAL_PERCENT = 1;
const FINAL_PERCENT = 99;

// Calculated initial percentages for each SRT upload status
const TRANSCRIBE_SEGMENTS_TO_DETERMINE_SPEAKERS_INITIAL_PERCENT = getPercent(
  PROJECT_CREATED_TO_UPLOADING_SEC +
    VIDEO_UPLOADING_SEC +
    VIDEO_UPLOADED_TO_SEPARATE_BACKGROUND_SEC +
    SEPARATE_BACKGROUND_SEC +
    SEPARATE_BACKGROUND_TO_TRANSCRIBE_SEGMENTS_SEC +
    TRANSCRIBING_SEGMENTS_SEC,
  DST_SRT_UPLOADING_SEC_FOR_60_SEC_VIDEO,
);
const DETERMINE_SPEAKERS_INITIAL_PERCENT = getPercent(
  PROJECT_CREATED_TO_UPLOADING_SEC +
    VIDEO_UPLOADING_SEC +
    VIDEO_UPLOADED_TO_SEPARATE_BACKGROUND_SEC +
    SEPARATE_BACKGROUND_SEC +
    SEPARATE_BACKGROUND_TO_TRANSCRIBE_SEGMENTS_SEC +
    TRANSCRIBING_SEGMENTS_SEC +
    TRANSCRIBING_SEGMENTS_TO_DETERMINING_SPEAKERS_SEC,
  DST_SRT_UPLOADING_SEC_FOR_60_SEC_VIDEO,
);
const DETERMINE_SPEAKERS_TO_VOICE_SUGGEST_INITIAL_PERCENT = getPercent(
  PROJECT_CREATED_TO_UPLOADING_SEC +
    VIDEO_UPLOADING_SEC +
    VIDEO_UPLOADED_TO_SEPARATE_BACKGROUND_SEC +
    SEPARATE_BACKGROUND_SEC +
    SEPARATE_BACKGROUND_TO_TRANSCRIBE_SEGMENTS_SEC +
    TRANSCRIBING_SEGMENTS_SEC +
    TRANSCRIBING_SEGMENTS_TO_DETERMINING_SPEAKERS_SEC +
    DETERMINING_SPEAKERS_SEC,
  DST_SRT_UPLOADING_SEC_FOR_60_SEC_VIDEO,
);
const VOICE_SUGGEST_INITIAL_PERCENT = getPercent(
  PROJECT_CREATED_TO_UPLOADING_SEC +
    VIDEO_UPLOADING_SEC +
    VIDEO_UPLOADED_TO_SEPARATE_BACKGROUND_SEC +
    SEPARATE_BACKGROUND_SEC +
    SEPARATE_BACKGROUND_TO_TRANSCRIBE_SEGMENTS_SEC +
    TRANSCRIBING_SEGMENTS_SEC +
    TRANSCRIBING_SEGMENTS_TO_DETERMINING_SPEAKERS_SEC +
    DETERMINING_SPEAKERS_SEC +
    DETERMINING_SPEAKERS_TO_VOICE_SUGGEST_SEC,
  DST_SRT_UPLOADING_SEC_FOR_60_SEC_VIDEO,
);
// Константы для загрузки видео
export const DST_SRT_UPLOADING_TASKS_SEC: {
  [key in Status]?: number;
} = {
  [Status.determineSpeakersDone]: DETERMINING_SPEAKERS_TO_VOICE_SUGGEST_SEC,
  [Status.determineSpeakersStarted]: DETERMINING_SPEAKERS_SEC,
  [Status.transcribeSegmentsDone]: TRANSCRIBING_SEGMENTS_TO_DETERMINING_SPEAKERS_SEC,
  [Status.transcribeSegmentsStarted]: TRANSCRIBING_SEGMENTS_SEC,
  [Status.voiceSuggestStarted]: VOICE_SUGGESTING_SEC,
};
export const INITIAL_PERCENT_FOR_DST_SRT_UPLOADING_STATUS: {
  [key in Status]?: number;
} = {
  [Status.determineSpeakersDone]: DETERMINE_SPEAKERS_TO_VOICE_SUGGEST_INITIAL_PERCENT,
  [Status.determineSpeakersStarted]: DETERMINE_SPEAKERS_INITIAL_PERCENT,
  [Status.transcribeSegmentsDone]: TRANSCRIBE_SEGMENTS_TO_DETERMINE_SPEAKERS_INITIAL_PERCENT,
  [Status.transcribeSegmentsStarted]: INITIAL_PERCENT,
  [Status.voiceSuggestStarted]: VOICE_SUGGEST_INITIAL_PERCENT, // 62
};
export const FINAL_PERCENT_FOR_DST_SRT_UPLOADING_STATUS: {
  [key in Status]?: number;
} = {
  [Status.determineSpeakersDone]: VOICE_SUGGEST_INITIAL_PERCENT,
  [Status.determineSpeakersStarted]: DETERMINE_SPEAKERS_TO_VOICE_SUGGEST_INITIAL_PERCENT,
  [Status.transcribeSegmentsDone]: DETERMINE_SPEAKERS_INITIAL_PERCENT,
  [Status.transcribeSegmentsStarted]: TRANSCRIBE_SEGMENTS_TO_DETERMINE_SPEAKERS_INITIAL_PERCENT,
  [Status.voiceSuggestStarted]: FINAL_PERCENT, // 99
};
